// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const combee: PokeData = {
  "id": 415,
  "name": "combee",
  "height": 3,
  "weight": 55,
  "base_experience": 49,
  "types": [
    PokeType.BUG,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "sweet-scent",
    "bug-buzz",
    "bug-bite",
    "struggle-bug"
  ],
  "moves": [
    "gust",
    "bug-buzz",
    "bug-bite",
    "chatter",
    "string-shot",
    "tailwind",
    "lunge",
    "pin-rush",
    "pounce",
    "acrobatics",
    "roost",
    "air-slash",
    "leech-steal"
  ],
  "evolution_chain": {
    "id": 214,
    "item": null,
    "species": [
      {
        "name": "combee",
        "order": 443,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "vespiquen",
        "order": 444,
        "types": [
          PokeType.BUG,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 415,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 21,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": {
              "name": "female"
            }
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 36,
    "speed": 70,
    "ability_power": 30
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
